import * as contactUs from '@/api/contactUs'

// 获取banner图
export function fetchBanner() {

	const param = {
		client: 0
	}

	return new Promise(function(resolve, reject){
		contactUs.getBanner(param)
			.then(function(result) {

				let responseBody = new Object()
				responseBody.imgUrl = result.data

				resolve(responseBody)
			})
	})
}

// 获取联系我们
export function fetchContactUs() {

	const param = {
		type: 7,
		language: 'zh'
	}

	return new Promise(function(resolve, reject){
		contactUs.getAbout(param)
			.then(function(result) {

				let responseBody = new Object()
				responseBody.content = result.data.content

				resolve(responseBody)
			})
	})
}

// 获取招聘英才
export function fetchJoinUs() {

    const param = {
        type: 8,
        language: 'zh'
    }

    return new Promise(function(resolve, reject){
        contactUs.getAbout(param)
            .then(function(result) {

                let responseBody = new Object()
                responseBody.content = result.data.content

                resolve(responseBody)
            })
    })
}